export default "__VITE_ASSET__mIT$rKwQ__"